import { Injectable, signal } from '@angular/core';
import { ISnippet } from '../interfaces/ISnippet';

@Injectable({
  providedIn: 'root'
})
export class SnippetsStore {

  public static instance: SnippetsStore;
  public readonly snippets = signal<ISnippet[]>(null);
  public readonly defaultSnippets = signal<ISnippet[]>(null);

  public constructor() {
    SnippetsStore.instance = this;
  }
}
